export const contactUsBg = require('./contact-us-bg.png?webp');
